import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateNewsletterForm from "../../forms/CreateOrUpdateNewsletterForm";

interface CreateNewsletterModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: string | null;
}

const CreateNewsletterModal: React.FC<CreateNewsletterModalProps> = ({
  open,
  onClose,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Create New Newsletter"
    width="md"
    loading={loading}
  >
    <CreateOrUpdateNewsletterForm loading={loading} error={error} />
  </AppModal>
);

export default CreateNewsletterModal;
